export const checkout = {
	checkout: {
		backToCart: 'Back',
		checkoutShippingAccounts: {
			title: 'Shipping Account',
			selectAccount: 'Please select the account that is paying for the shipment(s):',
			noteEmail: 'genservice@generac.com',
			error: 'Unable to load alternate carrier information at this time. We apologize for the inconvenience.',
		},
		checkoutDeliveryMethod: {
			title: 'Delivery Method',
			selectMethod: 'Select your method of delivery',
			primaryCarrier: 'Primary Carrier:',
			generacPrimaryCarrier: 'Generac Primary Carrier:',
			shippingConditions: 'Shipping Conditions:',
			note: 'Generac will reserve to cover freight costs for credit card orders plus payment in advance.',
			noteCharges: 'Actual freight charges will be applied to your invoice.',
		},
		wellsFargoCheckoutAbandonment: 'The cart has been reverted back to the original state due to checkout abandonment.',
	},
	checkoutProgress: {
		engineReplacementFormTab: 'AtD Attestation',
		deliveryAddress: 'Delivery Address',
		specialHandlingTab: 'Special Handling',
		specialHandling: {
			specialHandlingOptions: 'Special Handling options',
			selectOptions: 'Select your Special Handling Options:',
			fgAttentionMessage: 'These Special Handling options will apply only to your Finished Goods. Special Handling options for Service Parts shipping via LTL can be selected during the Service Parts step in Checkout.',
			residentialDeliverySelected: 'Residential Delivery has been pre-selected based on your address.',
		},
		engineReplacementForm: {
			acknowledgmentToDestroy: 'Acknowledgment to Destroy',
			modelNumberDestroyed: 'New Engine Model Number',
			serialNumberDestroyed: 'Generator Serial Number',
			accountId: 'Account ID',
			purchasingUser: 'Purchasing User',
			purchaseDate: 'Purchase Date',
			attestationCheckboxesTitle: 'Attestation Checkboxes',
			attestationCheckboxesText: 'I certify that the Replacement Engine was requested and installed according to applicable EPA requirements and instruction. A currently certified engine was not suitable for the repower because of:',
			attestationCheckboxesOptions: {
				PERFORMANCE: 'Performance',
				PACKAGING_OR_FIT: 'Packaging/Fit',
				packagingFitOptions: {
					electricalConnections: 'Electrical Connections',
					aftertreatmentPlacement: 'Aftertreatment Placement',
					equipmentEngineInterface: 'Equipment/Engine Interface',
					equipmentEngineInterfaceOptions: {
						physical: 'Physical',
						electrical: 'Electrical',
					},
					mountingLocations: 'Mounting Locations'
				}
			},
			destroyedByText: 'The Failed Engine has been destroyed by:',
			destroyedByOptions: {
				DESTROYED_BEYOND_REPAIR_SCRAPPED: 'Failed Engine block destroyed beyond repair in-use and scrapped',
				DESTROYED_BY_PIERCING_OR_DRILLING: 'Failed Engine block destroyed through piercing or drilling',
				RETURNED_TO_GENERAC: 'Failed Engine block returned to Generac Power Systems, Inc.',
			}
		},
		finishedGoods: 'Finished Goods',
		serviceParts: 'Service Parts',
		subscriptionInfo: 'Subscriptions',
		paymentDetails: 'Payment Details',
		reviewOrder: 'Review Order',
	},
	checkoutAddress: {
		shippingAddress: 'Delivery Address',
		shipToThisAddress: 'Ship Here',
		details: 'Order Details',
		powerPlayCreation: 'PowerPlay User Creation',
		powerPlayCreationMixedCartInfo: 'First Name and Last Name provided on this step related only to Subscription product.',
		defaultDeliveryAddress: 'Default',
		detailsForm: {
			poNumber: 'P.O. Number',
			poNumberPlaceholder: 'Enter P.O',
			firstName: 'First Name',
			firstNamePlaceholder: 'Enter Contact First Name',
			firstNamePowerPlaySellingPlaceholder: 'Enter First Name',
			lastNamePowerPlaySellingPlaceholder: 'Enter Last Name',
			lastName: 'Last Name',
			lastNamePlaceholder: 'Enter Contact Last Name',
			contactPhone: 'Contact Phone',
			contactPhonePlaceholder: 'Enter Contact Phone',
			role: 'Role',
			rolePlaceholder: 'Select Role',
			email: 'Email',
			emailPlaceholder: 'Enter Email',
			renewSubscription: 'Renew Subscription',
			renewSubscriptionPlaceholder: 'Select Subscription to renew',
		},
		ffAddress: 'Freight Forwarder',
		validateAddressErrorMessage:
			'The entered address does not match any existing address. To continue, enter the address correctly, please.',
		invalidAddress:
			'The house number or apartment/suit/unit number for this address is missing or invalid.',
		addressNotValidatedErrorMessage: 'Your Address is not validated. Please check it',
		subscriptionDetails: 'Subscription Details',
		subscriptionDetailsInfo: 'Details below will be used to create a Subscription.',
		currentlyAssignedTo: 'Currently assigned to: ',
		shippingDetailsInfo: 'Final Destination cannot be that of a freight terminal. All Broker, Freight Forwarder charges, Duties and Taxes to be paid by purchaser.',
		addressSectionTitle: 'Address',
		residentialAddress: 'Residential Address',
		additionalInstructionsTitle: 'Additional Instructions',
		noteTitle: 'Note: ',
		additionalInstructionsNoteText: 'If you require any additional information on your order, please contact a parts department support specialist to discuss. Failure to provide the requested information may result in delays processing your order.',
		checkoutSplitPaymentDialog: {
			title: 'Current order does not meet qualifications',
			compatibleProductsText: 'Wells Fargo financing covers the following materials in your cart:',
			nonCompatibleProductsText: 'The following products will need to be paid for using a second payment method:',
			infoText: 'We will first collect your shipping & payment details for the products financed through Wells Fargo. And then we will collect shipping & payment details for the remainder of the order.',
		},
		ffMixedCartWarning: 'Please note: ALL materials included in this order will be sent to the Freight Forwarder you selected. If you want your Service Parts shipped directly, please order those materials in a separate Cart. Please click the "I acknowledge" button to continue or "Cancel" to exit this order.',
		builderProgramFileUpload: {
			title: 'Builder Program File Upload',
			instructions: 'Upload up to 5 invoices or purchase orders. Accepted file types: PDF, JPG, and PNG. Each document should be no larger than 10MB.',
			dropZonePrefix: 'Drag and drop a copy of the builder invoice or purchase order or',
			browseFiles: 'browse files',
			uploadedDocumentsLabel: 'Uploaded builder documents',
			removeDocument: 'Remove {{documentName}}',
		},
	},
	checkoutOrderConfirmation: {
		confirmationOfOrder: 'Confirmation of Order:',
		thankYou: 'Thank you for your order!',
		thankYouWf: 'You are almost done!',
		invoiceHasBeenSent:
			'Order confirmation has been sent by email. You should receive it soon.',
		invoiceHasBeenSentByEmailWf: 'Your WF order is complete and confirmation has been sent by email. You should receive it soon.',
		powerPlayApiSellingMessage: 'A member of the PowerPlay team will be in touch soon regarding your API Subscription.',
		callToRepresentativeDAOrder:
			'Please call your onboarding representative for next steps in establishing your account.',
		creditCardPaymentInfoDAOrder:
			'You will need to enter your credit card details after clicking "Place Order."',
		orderItems: 'Order Items',
		orderPlacedSuccessfully: 'Order placed successfully',
		createAccount: 'Create an account?',
		placeTestOrder: 'Place Test Order',
		placeTestWfOrder: 'Place Test WF Order',
		createAccountForNext:
			'Create an account for <{{email}}> for a faster checkout on your next visit.',
		continueWithOrder: 'Continue With Order',
		continueWithOrderTitle: "Now let's checkout with the rest of your Cart.",
		continueWithOrderText: 'The remainder of your order is ready and waiting. Please proceed with the checkout of these items to complete your purchase.',
	},
	checkoutReview: {
		wellsFargoInfoMessage: {
			title: "Wells Fargo Financed Products Only",
			description: "This order covers only the products financed through WF Floor Plan. After submitting this order, we will continue with the remainder of the products from your cart.",
		},
		infoMessage:
			'The cost has been recalculated, pay attention to the order summary to see the details.<br><br> <span class="note">Please note:</span> All orders containing service parts and purchased using a credit card will have a pre-authorization hold placed on their card equaling the estimated shipping for the service parts. This hold is temporary and will be replaced by the actual shipping amount when your order is shipped.',
		offlineInfoMessage:
			'Pricing is not currently available, order will be placed with MSRP pricing',
		contactInformation: 'Contact Information',
		endDate: 'End Date',
		frequency: 'Frequency',
		nextOrder: 'Next Order Date',
		desiredDate: 'Desired Shipment Date',
		shippingDate: 'Shipping Date',
		errorPlacingOrder: "Order wasn't placed. Please try again.",
		successPlacingOrder: 'Order was successfully placed',
		confirmThatRead: 'I am confirming that I have read and agree with the',
		generacPrimaryCarrier: 'Generac Primary Carrier',
		dealerPrimaryCarrier: 'Dealer Primary Carrier',
		shippingConditions: 'Shipping Conditions',
		placeWfOrder: 'Place WF Order',
	}
};
